module.exports = __webpack_public_path__ + "static/img/7.63f8d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/5/7.png
// module id = 9a5G
// module chunks = 0